import { Theme } from '@material-ui/core';

export const MONO_FONT =
  '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace';

export function fluxTokens(theme: Theme) {
  const dark = theme.palette.type === 'dark';
  return {
    dark,
    pageBg: dark ? '#151820' : '#f7f8fa',
    panelBg: dark ? '#12151c' : '#ffffff',
    surface: dark ? '#181c25' : '#ffffff',
    surfaceHover: dark ? 'rgba(255,255,255,0.03)' : 'rgba(110,58,143,0.035)',
    inputBg: dark ? '#181c25' : '#ffffff',
    border: dark ? 'rgba(255,255,255,0.07)' : 'rgba(17,24,39,0.08)',
    borderStrong: dark ? 'rgba(255,255,255,0.12)' : 'rgba(17,24,39,0.14)',
    text: dark ? '#e6e9ef' : '#1f2733',
    textSecondary: dark ? '#9aa3b5' : '#5b6675',
    textMuted: dark ? '#7d8597' : '#8a94a6',
    accent: dark ? '#b794f6' : '#6e3a8f',
    accentStrong: dark ? '#8b5cf6' : '#6e3a8f',
    accentBg: dark ? 'rgba(139,92,246,0.14)' : 'rgba(110,58,143,0.08)',
    accentBorder: dark ? 'rgba(139,92,246,0.5)' : 'rgba(110,58,143,0.3)',
    chipBg: dark ? 'rgba(255,255,255,0.05)' : 'rgba(17,24,39,0.04)',
    chipBorder: dark ? 'rgba(255,255,255,0.1)' : 'rgba(17,24,39,0.1)',
    primaryGradient: 'linear-gradient(135deg, #9b6bff 0%, #7c3aed 100%)',
    success: dark ? '#4ade80' : '#15803d',
    successBg: dark ? 'rgba(34,197,94,0.12)' : 'rgba(34,197,94,0.1)',
    warning: dark ? '#fcd34d' : '#8a5a00',
    warningBg: dark ? 'rgba(245,158,11,0.14)' : 'rgba(245,158,11,0.12)',
    danger: dark ? '#fca5a5' : '#b42318',
    dangerBg: dark ? 'rgba(239,68,68,0.14)' : 'rgba(239,68,68,0.1)',
  };
}

export type FluxTokens = ReturnType<typeof fluxTokens>;
